import { NavTabPartialProps } from "@/components/custom/tabs/nav-tabs";
import { ReportSettingsTabs } from "./-report-tabs";
import { ScrollArea } from "@/components/ui/scroll-area";

export function Layout({
  children,
  tabs,
}: {
  children?: React.ReactNode;
  tabs?: NavTabPartialProps;
}) {
  return (
    <ReportSettingsTabs padding={false} {...tabs}>
      <ScrollArea
        viewport={{ className: "pt-3 h-lg:pt-4" }}
        className="-mr-4 pr-4 h-full"
      >
        {children}
      </ScrollArea>
    </ReportSettingsTabs>
  );
}
